import ListImportRequests from './views/List.vue'
import CreateImportRequest from './views/Create.vue'

export const ImportRequestsRoutes = [
  {
    path: '/import-requests',
    name: 'ListImportRequests',
    component: ListImportRequests,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'import:list'
    }
  },
  {
    path: '/import-request',
    name: 'CreateImportRequest',
    component: CreateImportRequest,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'import:create'
    }
  }
]
